<div class="new-pass-container" [ngClass]="{'!w-[327px] !p-6': bp.isCompact()}">
  <ng-container *ngIf="changeSucces===true; else showForm">
    <div class="success-message-container">
      <mg-icons class="success-message-icon" name="checkmark-circle">
      </mg-icons>
      <div class="success-message-text">
        <span class="success-message-title">¡Felicidades!</span>
        <span class="success-message-body"
          >Tu contraseña se actualizó correctamente</span
        >
      </div>
    </div>
    <div class="buttons-container">
      <mg-button routerLink="../login" class="w-full"
        >Ingresar a mi cuenta</mg-button
      >
      <ng-container *ngIf="(countdown && !countdown?.finished)">
        <span class="link-text"
          >Volverás automáticamente en {{ countdown.m + ':' + countdown.s
          }}</span
        ></ng-container
      >
    </div>
  </ng-container>
  <ng-template #showForm>
    <div class="heading-title">
      <span class="title-text">Confirma tu nueva contraseña</span>
    </div>
    <div class="w-full">
      <form class="form-styles" [formGroup]="newPasswordForm">
        <mg-input
          label="Contraseña"
          placeholder="**********"
          type="password"
          class="w-full"
          [ngClass]="{'min-w-[340px]': !bp.isCompact()}"
          [required]="true"
          [errors]="{
            required: 'Este campo no puede quedar vacío.',
            invalidPassword: 'La contraseña no cumple los requisitos'
          }"
          [control]="$any(newPasswordForm.get('password'))"
          [value]="newPasswordForm.value.password"
          mgTitle="Mostrar u ocultar contraseña"
        ></mg-input>
        <mg-input
          label="Contraseña"
          placeholder="**********"
          type="password"
          class="w-full"
          [ngClass]="{'min-w-[340px]': !bp.isCompact()}"
          [required]="true"
          [errors]="{
            required: 'Este campo no puede quedar vacío.',
            passwordIsNotEqual: 'Las contraseñas no coinciden.'
          }"
          [control]="$any(newPasswordForm.get('confirm'))"
          [value]="newPasswordForm.value.confirm"
          mgTitle="Mostrar u ocultar contraseña"
        ></mg-input>
      </form>
    </div>
    <div class="conditions-container">
      <span class="title-conditions"
        >Tu contraseña debe contener al menos:</span
      >
      <div class="condition-container">
        <mg-icons
          [ngClass]="{'condition-icon-success' : hasCapitalLetter === true,
          'condition-icon-error' : hasCapitalLetter === false,
        }"
          class="condition-icon"
          name="checkmark-circle"
        ></mg-icons>
        <span
          [ngClass]="{'condition-text-error' : hasCapitalLetter === false,
      }"
          class="condition-text"
          >Una letra mayúscula (A-Z)</span
        >
      </div>
      <div class="condition-container">
        <mg-icons
          [ngClass]="{'condition-icon-success' : hasLowercase === true,
          'condition-icon-error' : hasLowercase === false,
        }"
          class="condition-icon"
          name="checkmark-circle"
        ></mg-icons>
        <span
          [ngClass]="{'condition-text-error' : hasLowercase === false,
      }"
          class="condition-text"
          >Una letra minúscula (a-z)</span
        >
      </div>
      <div class="condition-container">
        <mg-icons
          [ngClass]="{'condition-icon-success' : hasNumber === true,
        'condition-icon-error' : hasNumber === false,
      }"
          class="condition-icon"
          name="checkmark-circle"
        ></mg-icons>
        <span
          [ngClass]="{'condition-text-error' : hasNumber === false,
      }"
          class="condition-text"
          >Un número (0-9)</span
        >
      </div>
      <div class="condition-container">
        <mg-icons
          [ngClass]="{'condition-icon-success' : hasSymbol === true,
        'condition-icon-error' : hasSymbol === false,
      }"
          class="condition-icon"
          name="checkmark-circle"
        ></mg-icons>
        <span
          [ngClass]="{'condition-text-error' : hasSymbol === false,
      }"
          class="condition-text"
          >Un símbolo ! " # $ % & ' ( ) *</span
        >
      </div>
      <div class="condition-container">
        <mg-icons
          [ngClass]="{'condition-icon-success' : hasLength === true,
        'condition-icon-error' : hasLength === false,
      }"
          class="condition-icon"
          name="checkmark-circle"
        ></mg-icons>
        <span
          [ngClass]="{'condition-text-error' : hasLength === false,
      }"
          class="condition-text"
          >Al menos 10 caracteres</span
        >
      </div>
    </div>
    <div class="buttons-container">
      <mg-button
        [disabled]="!newPasswordForm.value.password || !newPasswordForm.value.confirm"
        [loading]="loading"
        class="w-full"
        (click)="onSubmit()"
        (keypress.enter)="onSubmit()"
        (keypress.space)="onSubmit()"
        >Confirmar</mg-button
      >
      <span routerLink="../login" class="cancel-label">Cancelar</span>
    </div>
  </ng-template>
</div>
